// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"ribbon_ribbon__AvnEf","large":"ribbon_large__u9Nb_"};